var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#212121"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_609_255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 8.84792H10.8904V8.23389H5.07749C4.87281 8.23389 4.75 8.39763 4.75 8.56137V8.84792Z",
    fill: "#FFF0A4",
    stroke: "#FFF0A4",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98428 12L11.2591 8.72515C11.3819 8.60234 11.3819 8.39766 11.2591 8.27485L7.98428 5L7.77961 5.20468C7.6568 5.32749 7.6568 5.53216 7.77961 5.69591L10.6042 8.52047L7.77961 11.345C7.6568 11.4678 7.6568 11.6725 7.77961 11.8363L7.98428 12Z",
    fill: "#FFF0A4",
    stroke: "#FFF0A4",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_609_255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(4 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.4d1457758f4df2dbb958afe81816209c.svg";
export { ForwardRef as ReactComponent };